"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGroupDecorator = void 0;
const react_1 = require("react");
const ToolbarControlsWithGroup_1 = require("../controls/ToolbarControlsWithGroup");
const types_1 = require("../types");
const getPropsFromDecorators_1 = require("./getPropsFromDecorators");
const defaultGroupDecorator = (items, groups, payload, canAction) => {
    const itemList = items.map((item) => {
        const { decorators = [], disabled, hidden } = item, restItemProps = __rest(item, ["decorators", "disabled", "hidden"]);
        const decoratedProps = (0, getPropsFromDecorators_1.getPropsFromDecorators)(decorators || [], payload || null, canAction);
        return Object.assign(Object.assign(Object.assign(Object.assign({}, restItemProps), { payload }), decoratedProps), { disabled: decoratedProps.disabled || disabled, hidden: decoratedProps.hidden || hidden });
    });
    const toolbarGroupItems = groups
        .map((group) => {
        return {
            title: group.title,
            disabled: group.disabled,
            hidden: group.hidden,
            iconSrc: group.iconSrc,
            id: group.id,
            items: itemList.filter((item) => item.groupId === group.id && !group.hidden)
        };
    })
        .filter((group) => group.items.length)
        .map((group) => {
        const { id, hidden, disabled, items } = group;
        return {
            id,
            type: types_1.TOOLBAR_ITEM_TYPE.customControl,
            hasOffset: true,
            hidden: hidden,
            payload,
            render: () => (0, react_1.createElement)(ToolbarControlsWithGroup_1.ToolbarControlsWithGroup[types_1.TOOLBAR_GROUP_TYPE.splitButton], Object.assign(Object.assign({}, group), { text: group.title, disabled: disabled ||
                    items.reduce((acc, item) => {
                        if (item.type === types_1.TOOLBAR_ITEM_TYPE.button) {
                            return acc && !!item.disabled;
                        }
                        return acc;
                    }, true), 'data-selector-id': (id === null || id === void 0 ? void 0 : id.toString()) || 'toolbar-splitbutton' }))
        };
    });
    return items.reduce((acc, item) => {
        if (item.type === types_1.TOOLBAR_ITEM_TYPE.button && item.groupId) {
            const foundGroup = toolbarGroupItems.find(({ id }) => id === item.groupId);
            if (!foundGroup) {
                const { id } = item;
                acc.push(Object.assign(Object.assign({}, item), { payload, 'data-selector-id': id === null || id === void 0 ? void 0 : id.toString() }));
            }
            else if (!acc.some((toolbarItem) => toolbarItem === foundGroup)) {
                acc.push(foundGroup);
            }
        }
        if (!item['groupId']) {
            acc.push(Object.assign(Object.assign({}, item), { payload }));
        }
        return acc;
    }, []);
};
exports.defaultGroupDecorator = defaultGroupDecorator;
//# sourceMappingURL=defaultGroupDecorator.js.map